/**
 * @generated SignedSource<<a4cc4b190c5eea1ba35611e4f01a4951>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EventCompetitionCreateEventFromCompetitionMutation$variables = {
  competitionId: string;
};
export type EventCompetitionCreateEventFromCompetitionMutation$data = {
  readonly createEventFromCompetition: {
    readonly node: {
      readonly id: string;
      readonly slug: string;
    };
  };
};
export type EventCompetitionCreateEventFromCompetitionMutation = {
  response: EventCompetitionCreateEventFromCompetitionMutation$data;
  variables: EventCompetitionCreateEventFromCompetitionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "competitionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "competitionId",
        "variableName": "competitionId"
      }
    ],
    "concreteType": "EventEdge",
    "kind": "LinkedField",
    "name": "createEventFromCompetition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventCompetitionCreateEventFromCompetitionMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EventCompetitionCreateEventFromCompetitionMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "585103f771ef4d9d2be36d42ba815b38",
    "id": null,
    "metadata": {},
    "name": "EventCompetitionCreateEventFromCompetitionMutation",
    "operationKind": "mutation",
    "text": "mutation EventCompetitionCreateEventFromCompetitionMutation(\n  $competitionId: ID!\n) {\n  createEventFromCompetition(competitionId: $competitionId) {\n    node {\n      id\n      slug\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4bd140056bf79c2fcf5e7e0301041504";

export default node;
